// Dark image overlay — dark bottom, fades to transparent top (marquee cards, photo overlays)
export const GRADIENT_DARK_BOTTOM =
  'linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.18) 45%, transparent 100%)'

// Subtle blue brand tint — light section backgrounds
export const GRADIENT_BLUE_TINT =
  'linear-gradient(135deg, rgba(3,53,183,0.06), rgba(0,180,216,0.04))'

// Card hero fade to white — VOD / platform hero image blends into white card body
export const GRADIENT_FADE_TO_WHITE =
  'linear-gradient(to bottom, transparent 20%, rgba(255,255,255,0.85) 80%, white 100%)'

export const GRADIENT_TEXT = {
  backgroundImage: 'linear-gradient(135deg,#0335b7,#00b4d8)',
  WebkitBackgroundClip: 'text' as const,
  WebkitTextFillColor: 'transparent' as const,
  backgroundClip: 'text' as const,
}

// Platform brand colors are tuned for light backgrounds; as TEXT on the dark
// navy panels several fall below WCAG AA (Rubika 2.6:1, LinkedIn 3.2:1,
// Soroush 3.7:1 on #0a1628). Mixing 35% white lifts all of them above 5.7:1
// while keeping the hue. Use for text/glyphs only — tinted backgrounds,
// borders, and glows keep the raw brand color. Returns a plain hex (not CSS
// color-mix) so framer-motion can interpolate it in `animate` props.
export function onDark(color: string): string {
  const m = color.match(/^#([0-9a-f]{6})$/i)
  if (!m) return color
  const n = parseInt(m[1], 16)
  const mix = (v: number) => Math.round(v + (255 - v) * 0.35)
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(mix)
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`
}

export const GRADIENT_TEXT_BLUE = {
  backgroundImage: 'linear-gradient(90deg,#3b82f6,#00b4d8)',
  WebkitBackgroundClip: 'text' as const,
  WebkitTextFillColor: 'transparent' as const,
  backgroundClip: 'text' as const,
}
